/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Amountexceedstarget5Inputs */

const en_coinvestments_submitticketsize_modal_amountexceedstarget5 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Amountexceedstarget5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount cannot exceed the target amount`)
};

/**
* | output |
* | --- |
* | "Amount cannot exceed the target amount" |
*
* @param {Coinvestments_Submitticketsize_Modal_Amountexceedstarget5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_amountexceedstarget5 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Amountexceedstarget5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Amountexceedstarget5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_amountexceedstarget5(inputs)
});
export { coinvestments_submitticketsize_modal_amountexceedstarget5 as "coInvestments_submitTicketSize_modal_amountExceedsTarget" }